import { call, put } from "redux-saga/effects";
import { getToken } from "../authentication";
import { IGetAlertTableData } from "../actions/alert-table-data";
import axios from 'axios';
import { IAlertActions } from "../actions/alerts";
import { Alert, TAlertType } from "../redux/models";

type FilterAlertRequest = {
    vehicleID?: string;
    alertName?: string;
    model?: string;
    subModel?: string;
    location?: string;
    subLocation?: string;
    startDate?: string;
    endDate?: string;
    batteryId?: string;
    customerId?: string;
    timeFrame?: string;
    alertType: TAlertType;
    pageNo: number;
    pageSize: number;
    sortDirection: "asc" | "desc";
    sortKey: string;
    org_id: any;
    customer_id: any;
    timeZone: any;
};
export function* getAlertTableData(params: any) {
    try {
        let { data } = yield call(getAlertTableDataApi, params);
        yield put({
            type: "STORE_ALERT_TABLE_DATA",
            payload: data,
        });
    } catch (err) {
        console.error("Unable to fetch charging Station Details", err);
    }
}
export function* getFilteredAlertDataCount(params: IAlertActions) {
    try {
        const data: any = yield call(getFilteredAlertsCount, params);
        yield put({
            type: "STORE_FILTERED_ALERT_COUNT_UPDATE",
            payload: {
                smartCount: data[0].smart,
                bmsCount: data[0].bms,
                mcCount: data[0].mc,
                vcuCount: data[0].vcu,
                chargerCount: data[0].charger,
            },
        } as any);
    } catch (error) {
        console.log("get Alerts error", error);
    }
}
async function getFilteredAlertsCount(params: IAlertActions) {
    let response = [];
    response = await Promise.all([getAllFilteredAlertsCount(params)]);
    return response;
}
async function getAllFilteredAlertsCount(params: IAlertActions) {
    const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    let request: FilterAlertRequest = {
        alertType: params.payload.alertType,
        pageNo: params.payload.pagination.pageNumber,
        pageSize: params.payload.pagination.pageSize,
        sortDirection: params.payload.sort.direction === "descend" ? "desc" : "asc",
        sortKey: params.payload.sort.fieldName,
        org_id: params.payload.org_id,
        customer_id: params.payload.customer_id,
        timeZone: browserTimeZone,
    };
    const tokenRes = await getToken();
    const response = await axios.post(
        process.env.REACT_APP_WEBAPPAPI + "/getfilteralertdata",
        {
            ...request,
            pageable: true,
            org_id: params.payload.org_id,
        },
        {
            headers: {
                "Content-Type": "application/json",
                Authorization: tokenRes.token!,
            },
        }
    );
    return response.data.data as Alert;
}
async function getAlertTableDataApi(params: any) {
    const tokenRes = await getToken();
    const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await axios.post(
        process.env.REACT_APP_WEBAPPAPI + "/getAllOpenAlerts",
        {
            alertType: params.payload.alertType,
            pageNo: params.payload.pageNo,
            pageSize: params.payload.pageSize,
            sortDirection: params.payload.sortDirection,
            sortKey: params.payload.sortKey,
            pageable: false,
            org_id: params.payload.org_id,
            customer_id: params.payload.customer_id,
            timeZone: browserTimeZone,
        },
        {
            headers: {
                "Content-Type": "application/json",
                Authorization: tokenRes.token!,
            },
        }
    );
    return response.data as any;
}